import {
  useMutation,
  type UseMutationOptions,
  type UseMutationResult,
} from '@tanstack/react-query'

import type { CustomError } from '@front/type/api'

import { axiosPost } from '../logic/axios/wrappers/axios.post.wrapper'

import { adminLoginUrl } from './config'

export interface LoginData {
  email: string
  password: string
  ipAddress: string
}

export interface LoginResult {
  user: {
    id: number
  }
  accessToken: string
}

export const useAdminLoginMutation = (
  options?: UseMutationOptions<LoginResult | undefined, CustomError, LoginData>,
): UseMutationResult<LoginResult | undefined, CustomError, LoginData> => {
  return useMutation({
    mutationFn: (data: LoginData) => {
      return axiosPost<LoginResult>(adminLoginUrl, {
        password: data.password,
        subject: data.email,
        ipAddress: data.ipAddress,
      })
    },
    ...options,
  })
}
